import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, DropdownOutline, DropdownTrigger } from '../../../../../infra/ui/dropdown';
import { ButtonOption, DropdownList } from '../dropdown-list';
import filterStyles from '../filters/styles.module.scss';
var labelBySort = {
    createdAtDesc: 'Newest first',
    createdAtAsc: 'Oldest first',
    successDesc: 'Most successful',
    displayNameAsc: 'Alphabetical',
};
var sortOptions = ['createdAtDesc', 'createdAtAsc', 'successDesc', 'displayNameAsc'];
export var SortDropdown = function (_a) {
    var sortOrder = _a.sortOrder, setSortOrder = _a.setSortOrder;
    return (_jsx("div", { className: filterStyles['extra-filter-dropdown__container'], children: _jsxs(Dropdown, { children: [_jsx(DropdownTrigger, { className: filterStyles['extra-filter-dropdown'], children: _jsx(DropdownOutline.Trigger, { label: labelBySort[sortOrder] }) }), _jsx(DropdownList, { children: sortOptions.map(function (sortOption) { return (_jsx(ButtonOption, { id: "sort-engage-list-by-".concat(sortOption), onClick: function () { return setSortOrder(sortOption); }, children: labelBySort[sortOption] }, sortOption)); }) })] }) }));
};
